import * as React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import PageWrapper from './src/components/core/PageWrapper';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
}) => {
  return <PageWrapper element={element} />;
};
